import { useGlobalConfig } from '@ad-lucy/context/adData';
import { parseLinkout } from '@ad-lucy/context/adData/contentData/utils/transformComponentsAPI';
import { RoutingUtils } from '@ad-lucy/utils';
import { useCallback } from 'react';

export type WindowOpenReturnValues = {
  windowOpen: (link: string) => void;
};

export function useWindowOpen(): WindowOpenReturnValues {
  const { data: globalConfig } = useGlobalConfig();

  const windowOpen = useCallback(
    (link: string): void => {
      RoutingUtils.windowOpen(
        parseLinkout(link, (globalConfig?.meta?.linkoutParameters as string) ?? ''),
      );
    },
    [globalConfig?.meta?.linkoutParameters],
  );

  return {
    windowOpen,
  };
}
